import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportTitleFormat } from 'src/app/_objects/report-template';
import { REGULAR_EXPRESSION, DYNAMIC_SELECT_ITEM, DYNAMIC_SELECT_TEMPLATENAME_VISOL, PROP_DYNAMIC_DATEFORMAT } from 'src/app/app.constants';
import { REPORT_TEMPLATE___APPLICATION_TYPE, StorageService } from 'src/app/_services/storage.service';

@Component({
    selector: 'app-report-template-edit-report-name-format-dialog',
    styleUrls: ['./report-template-edit-report-name-format-dialog.component.scss'],
    templateUrl: './report-template-edit-report-name-format-dialog.component.html',
    standalone: false
})
export class ReportTemplateEditReportNameFormatDialogComponent implements OnInit {

  isEdit = false;
  tempFormatItem: ReportTitleFormat;
  typeControl = new UntypedFormControl('', [Validators.required]);
  valueMaxLength = 100;
  valueControl = new UntypedFormControl(null, [Validators.required, Validators.maxLength(this.valueMaxLength)]);
  dynamicValueControl = new UntypedFormControl(null, [Validators.required]);
  formatMaxLength = 100;
  formatSelectItem = PROP_DYNAMIC_DATEFORMAT;
  formatControl = new UntypedFormControl(null, [Validators.maxLength(this.formatMaxLength)]);
  dynamicSelectItem = DYNAMIC_SELECT_ITEM.filter(_ => _.label !== "pageNumber");
  dynamicSelectItem_VISOL = DYNAMIC_SELECT_TEMPLATENAME_VISOL;
  isVisol = false;
  constructor(
    public dialogRef: MatDialogRef<ReportTemplateEditReportNameFormatDialogComponent>,
    private storageService: StorageService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    const applicationType = this.storageService.fetchApplicationType(REPORT_TEMPLATE___APPLICATION_TYPE);
    if (applicationType) {
      this.isVisol = applicationType.IsVisol;
      this.valueControl.setValidators(Validators.pattern(REGULAR_EXPRESSION.COMMONPATTERN))
    }
    this.isEdit = this.data.isEdit;
    this.tempFormatItem = this.data.formatItem;
    if (!this.isEdit) {
      this.typeControl.setValue('static');
      this.valueControl.setValue('');
      this.formatControl.setValue('');
    } else {
      this.typeControl.setValue(this.tempFormatItem.type);
      if (this.tempFormatItem.type === 'dynamic') {
        this.dynamicValueControl.setValue(this.tempFormatItem.value);
        this.valueControl.setValue('');
      } else {
        this.valueControl.setValue(this.tempFormatItem.value);
        this.dynamicValueControl.setValue('');
      }
      this.formatControl.setValue(this.tempFormatItem.format);
    }
    this.onChangeAtType();
  }
  submit() {
    const formatItem: ReportTitleFormat = new ReportTitleFormat();
    if (this.typeControl.value === 'dynamic') {
      formatItem.value = this.dynamicValueControl.value;
    } else {
      formatItem.value = this.valueControl.value;
    }
    formatItem.type = this.typeControl.value;
    if (formatItem.type === 'static' || !this.formatControl.value) {
      formatItem.format = null;
    } else {
      formatItem.format = this.formatControl.value;
    }
    this.dialogRef.close(formatItem);
  }
  onChangeAtType() {
    if (this.typeControl.value === 'static') {
      this.formatControl.disable();
      this.formatControl.setValue('');
    } else {
      this.formatControl.enable();
      this.formatControl.setValue(this.tempFormatItem.format);
    }
  }
  onChangeAtDynamicValue() {
    if (this.dynamicValueControl.value === 'inspection[0].inspectionDate' || this.dynamicValueControl.value === 'system.now') {
      this.formatControl.enable();
      this.formatControl.setValue(this.tempFormatItem.format);
    } else {
      this.formatControl.disable();
      this.formatControl.setValue('');
    }
  }
}
